import { render, staticRenderFns } from "./ProfileView.vue?vue&type=template&id=0235b485&"
import script from "./ProfileView.vue?vue&type=script&lang=ts&"
export * from "./ProfileView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0235b485')) {
      api.createRecord('0235b485', component.options)
    } else {
      api.reload('0235b485', component.options)
    }
    module.hot.accept("./ProfileView.vue?vue&type=template&id=0235b485&", function () {
      api.rerender('0235b485', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/member/profile/ProfileView.vue"
export default component.exports